var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._l((_vm.Values),function(ex,index){return _c('div',{key:index},[(ex in _vm.expendables)?_c('div',[_c('b-img',{attrs:{"src":_vm.expendables[ex].path}}),_c('font-awesome-icon',{attrs:{"icon":_vm.expendables[ex].direction}})],1):_c('b-badge',{attrs:{"variant":"warning"}},[_vm._v(" Aucune énergie ")])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }